import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/button'
import { createModal, useModalize } from '@/components/modalize/mui'
import { colors } from '@/styles'
import CautionIcon from '../modal/caution-icon.svg'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fcf5d8;
  height: 112px;
  width: 100%;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 24px;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  button {
    width: 50%;
  }
`

const Title = styled.h5`
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
`

const Paragraph = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${colors.grey48};
  margin: 8px 0 24px;
`

const DocumentModal = ({ callback }) => {
  const { close } = useModalize()
  const { t } = useTranslation()

  const handleCancel = () => {
    close()
  }

  const handleExit = () => {
    close()
    callback()
  }

  return (
    <Container>
      <IconWrapper>{<img src={CautionIcon} alt="icon" />}</IconWrapper>
      <TextWrapper>
        <Title>{t('l.progress_lost_modal.title', 'Your progress will be lost')}</Title>
        <Paragraph>
          {t(
            'l.progress_lost_modal.content.text',
            'If you exit Contract Builder now, your progress will not be saved.'
          )}
        </Paragraph>
        <ButtonWrapper>
          <Button theme="secondary" onClick={handleCancel}>
            {t('common.cancel', 'Cancel')}
          </Button>
          <Button theme="primary" onClick={handleExit}>
            {t('l.progress_lost_modal.confirm.text', 'Exit')}
          </Button>
        </ButtonWrapper>
      </TextWrapper>
    </Container>
  )
}

const showProgressLostModal = createModal(DocumentModal, { showClose: false, width: '416px' })

export default showProgressLostModal
